import { Reducer } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { CLICK_SELECT_USER_INVITE, SET_SELECT_USER_INVITE_FALSE, ToggleActionTypes } from 'action-creators/eventsBooking';

export interface ToggleState {
  value: boolean;
}

const initialState: ToggleState = {
  value: false,
};

const reducer: Reducer<ToggleState, ToggleActionTypes> = (state = initialState, action) => {
  switch (action.type) {
    case CLICK_SELECT_USER_INVITE:
      return {
        ...state,
        value: !state.value,
      };
    case SET_SELECT_USER_INVITE_FALSE:
      return {
        ...state,
        value: false,
      };
    default:
      return state;
  }
};

const persistConfig = {
  storage,
  version: 1,
  key: 'toggle',
};

export default persistReducer(persistConfig, reducer);